import { create } from "zustand";

interface NetworkState {
  isOnline: boolean;
  wasOffline: boolean;
  lastOnlineAt: number | null;
  setOnline: (online: boolean) => void;
  markOfflineWarningDismissed: () => void;
}

const initialOnline = typeof window !== "undefined" ? navigator.onLine : true;

export const useNetworkStore = create<NetworkState>((set) => ({
  isOnline: initialOnline,
  wasOffline: false,
  lastOnlineAt: initialOnline ? Date.now() : null,
  setOnline: (online) =>
    set((state) => ({
      isOnline: online,
      wasOffline: state.wasOffline || (!online && state.isOnline),
      lastOnlineAt: online ? Date.now() : state.lastOnlineAt,
    })),
  markOfflineWarningDismissed: () =>
    set(() => ({
      wasOffline: false,
    })),
}));

if (typeof window !== "undefined") {
  window.addEventListener("online", () => {
    useNetworkStore.getState().setOnline(true);
  });
  window.addEventListener("offline", () => {
    useNetworkStore.getState().setOnline(false);
  });
}
